import { faClipboard, faListCheck, faRepeat } from '@fortawesome/free-solid-svg-icons';
import demo_task from '../../files/home/demo_task.jpg';
import demo_project_1 from '../../files/home/demo_project_1.png';
import demo_project_2 from '../../files/home/demo_project_2.png';
import demo_main_1 from '../../files/home/demo_main_1.png';
import demo_main_2 from '../../files/home/demo_main_2.png';
import demo_main_3 from '../../files/home/demo_main_3.png';
import demo_main_4 from '../../files/home/demo_main_4.png';
import demo_widget_1 from '../../files/home/demo_widget_1.png';
import demo_widget_2 from '../../files/home/demo_widget_2.png';
import demo_label_1 from '../../files/home/demo_label_1.png';
import demo_param_1 from '../../files/home/demo_parametr_1.png';
import demo_param_2 from '../../files/home/demo_parametr_2.png';
import demo_user_1 from '../../files/home/demo_user_1.png';
import demo_user_2 from '../../files/home/demo_user_2.png';
import './Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
//import './styles.css';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';

import { ReactComponent as Icon_Flag } from "../../files/home/icon_flag_1.svg";
import { ReactComponent as Icon_Online } from "../../files/home/icon_online.svg";

function Home() {


    return (
        <>
            <div className='block block_01' >
                <div className='row'>
                    <div className='col-md-6 '>
                        <h1 className="block_01_text"><div>
                            <b>BIZ-Трекер</b> <br></br> легкий сервис для работы с задачами</div>
                        </h1>
                        <div className='block_01_description'>Все дела под контролем. Создавайте задачи, распределяйте по компаниям, проектам, ставьте сроки и назначайте ответственных. Работайте в команде или ведите личные задачи — всё в одном месте.</div>

                        <div className='row mt-20'>
                            <div className='col-lg-12 mt-20_'>
                                <div className='block_01_plus'>
                                    <Icon_Flag className="block_01_plus_icon" />
                                    100% Российское ПО
                                </div>
                            </div>
                            <div className='col-lg-12 mt-20 mb-20'>
                                <div className='block_01_plus'>
                                    <Icon_Online className="block_01_plus_icon" />
                                    Работает в режиме реального времени
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <img src={demo_task} className='block_01_img' style={{ width: '100%' }}></img>
                    </div>
                </div>

            </div>
            <div className='block block_01'>
                <div className='row'>
                    <div className='col-lg-4 mb-20'>
                        <div className='block_task_item'>
                            <div className="icon"><FontAwesomeIcon icon={faListCheck} /></div>
                            <h2 className='block_sub_title text-center'>Задачи</h2>
                            <div className='description'>
                                Обычные задачи с ответственными: назначайте исполнителей, наблюдателей, ставьте сроки, ведите статусы.
                                <ul className='main_ul'>
                                    <li>Провести собеседование</li>
                                    <li>Восстановить доступ к папке</li>
                                    <li>Заказать канцелярию</li>
                                    <li>Подготовить пакет документов</li>
                                </ul>
                                Вы сразу видите, кто за что отвечает, на каком этапе работа и не срываются ли сроки.
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-20'>
                        <div className='block_task_item'>
                            <div className="icon"><FontAwesomeIcon icon={faRepeat} /></div>
                            <h2 className='block_sub_title text-center'>Переодические задачи</h2>
                            <div className='description'>
                                Систематизируйте рутину, которая повторяется: ежедневно, еженедельно, ежемесячно, ежегодно.
                                <br></br>
                                <ul className='main_ul'>
                                    <li>Закрытие месяца</li>
                                    <li>Сверка актов</li>
                                    <li>Инвентаризация</li>
                                    <li>Резервное копирование</li>
                                </ul>
                                Переодические задачи убирают риск «забыть про ежемесячное действие» и делают рутину прозрачной.
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-20'>
                        <div className='block_task_item'>
                            <div className="icon"><FontAwesomeIcon icon={faClipboard} /></div>
                            <h2 className='block_sub_title text-center'>Доски Kanban</h2>
                            <div className='description'>
                                Делает работу команды прозрачной: задачи — в карточках, этапы — в колонках, прогресс — на виду.
                                Это инструмент, который отражает реальный процесс и помогает управлять потоком задач.
                                <ul className='main_ul'>
                                    <li>Установить обновления</li>
                                    <li>Баннер для контекстной рекламы</li>
                                    <li>Подготовить письмо</li>
                                    <li>Заказать канцелярию</li>
                                </ul>
                                Настраивайте доски под реальные процессы вашей команды
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='block block_01'>
                <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                    <SwiperSlide><img src={demo_main_1} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                    <SwiperSlide><img src={demo_main_2} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                    <SwiperSlide><img src={demo_main_3} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                    <SwiperSlide><img src={demo_main_4} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                </Swiper>
            </div>
            <div className='block_difficultly'>
                <div className='block block_01'>
                    <h2 className="block_title text-white">От простого к сложному</h2>
                    <div className="block_sub_title mt-25 text-white">
                        Для создания задачи достаточно ввести ее название.<br></br>
                        Расширить возможности задачи можно с помощью добавления виджетов на стену.
                    </div>
                    <div className='row' style={{ marginTop: '50px' }}>
                        <div className='col-md-5'>
                            <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                                <SwiperSlide><img src={demo_widget_1} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                                <SwiperSlide><img src={demo_widget_2} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                            </Swiper>
                        </div>
                        <div className='col-md-7'>
                            <div className='block_difficultly_right'>
                                <h3 className='block_title pt-15'>Виджеты</h3>
                                <div className='description mt-25'>
                                    Выджеты позволяют расширить функциональность задачи.
                                    На стену задачи можно добавить сколько угодно виджетов.
                                    Виджеты можно перемещать по стене, удалять.
                                    <ul className='mt-10 main_ul'>
                                        <li><b>Сроки</b> - установка сроков выполнения задачи. В случае если задача просроена, то она будет подсвечена. Если срок задачи не наступил, то она будет во вкладке «Будущая»</li>
                                        <li><b>Приоритет</b> - в зависимости от выбранного приоритета задача будет подсвечена соответствующим цветом.</li>
                                        <li><b>Метки</b> - позволяют визуально маркировать задачи, а затем быстро фильтровать, находить задачи. Метки заранее создаются в справочниках.</li>
                                        <li><b>ТекстHTML</b> - Текс с возможностью HTML разметки. Использоуется для описание, инструкций...</li>
                                        <li><b>Чек-лист</b> - список шагов, который помогает выполнить задачу. Возможно запретить выполнение задачи, до выполнения всех пунктов чек-листа.</li>
                                        <li><b>Файлы</b> - виджет добавления файлов</li>
                                        <li><b>Параметры</b> - виджет позволяет добавить заранее созданные в справочнике параметры на стену задачи. Например «Список сотрудников», «Цена»...</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <div className='block block_02'>
                <div className='row'>
                    <div className='col-lg-4'>
                        <h2 className='block_title'>Проекты</h2>
                        <ul className='block_text main_ul'>
                            <li>Иерархия любой вложенности</li>
                            <li>Настройка отображения во всех объектах или только указанных (задача, переодическая задача, доска)</li>
                            <li>Настройка доступа проекта всем пользователям или указанным</li>
                        </ul>
                    </div>
                    <div className='col-lg-8'>
                        <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                            <SwiperSlide><img src={demo_project_1} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                            <SwiperSlide><img src={demo_project_2} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='block block_02'>
                <div className='row'>
                    <div className='col-lg-8 order-1 order-lg-0'>
                        <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                            <SwiperSlide><img src={demo_label_1} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                        </Swiper>
                    </div>
                    <div className='col-lg-4 order-0 order-lg-1'>
                        <h2 className='block_title'>Метки</h2>
                        <ul className='block_text main_ul'>
                            <li>Выбор произвольного цвета или цвета из представленного шаблона</li>
                            <li>Настройка отображения во всех объектах или только указанных (задача, переодическая задача, доска)</li>
                            <li>Настройка отображения во всех проектах или указанных</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='block block_02'>
                <div className='row'>
                    <div className='col-lg-4'>
                        <h2 className='block_title'>Параметры</h2>
                        <ul className='block_text main_ul'>
                            <li>5 типов параметров (логический, число, строка, справочник, дата)</li>
                            <li>Настройка отображения во всех объектах или только указанных (задача, переодическая задача, доска)</li>
                            <li>Настройка отображения во всех проектах или указанных</li>
                        </ul>
                    </div>
                    <div className='col-lg-8'>
                        <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                            <SwiperSlide><img src={demo_param_2} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                            <SwiperSlide><img src={demo_param_1} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
            <div className='block block_02'>
                <div className='row'>
                    <div className='col-lg-8 order-1 order-lg-0'>
                        <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} className="mySwiper">
                            <SwiperSlide><img src={demo_user_1} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                            <SwiperSlide><img src={demo_user_2} alt="BIZ-Трекер проекты" width='100%' className='img_slider' /></SwiperSlide>
                        </Swiper>
                    </div>
                    <div className='col-lg-4 order-0 order-lg-1'>
                        <h2 className='block_title'>Пользователи</h2>
                        <ul className='block_text main_ul'>
                            <li>Пользователей можно разделить по ролям (пользователь, администратор)</li>
                            <li>Администратору доступны все функции сервиса</li>
                            <li>Пользователь видит тольк те задачи, в которых он ответственный, а также свои задачи</li>
                            <li>Для пользователя можно ограничить доступ к проектам</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home;


